import React from 'react';
import { AttributeTypeFormModalView } from './AttributeTypeFormModalView';
import {
    useAttributeTypeForm,
    type AttributeTypeFormValues,
} from './useAttributeTypeForm';

type AttributeTypeFormModalProps = {
    error: string | null;
    initialValues: AttributeTypeFormValues | null;
    isOpen: boolean;
    isSubmitting: boolean;
    mode: 'create' | 'edit';
    onClose: () => void;
    onSubmit: (input: AttributeTypeFormValues) => void;
};

/**
 * Container for the Add / Edit attribute-type modal: instantiates the form-state
 * hook and hands its output (plus the modal-chrome props) to the render-only
 * View.
 */
export const AttributeTypeFormModal: React.FC<AttributeTypeFormModalProps> = ({
    error,
    initialValues,
    isOpen,
    isSubmitting,
    mode,
    onClose,
    onSubmit,
}) => {
    const form = useAttributeTypeForm({
        initialValues: initialValues ?? undefined,
        isOpen,
        mode,
        onSubmit,
    });

    return (
        <AttributeTypeFormModalView
            error={error}
            form={form}
            isOpen={isOpen}
            isSubmitting={isSubmitting}
            mode={mode}
            onClose={onClose}
        />
    );
};
